import type { SVGProps } from 'react';

const SvgInsertDriveFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M4.01 2 4 22h16V8l-6-6zM13 9V3.5L18.5 9z" />
  </svg>
);
export default SvgInsertDriveFile;
